import { useEffect, useState } from "react";
import { api } from "@/api/client";
import { fmtDate } from "@/components/common";
import { Loader2, Shield } from "lucide-react";

const MODS = ["auth","users","roles","task","approval_workflow","whatsapp","memory","settings"];

export default function MobileAudit() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [module, setModule] = useState("");

  const load = async () => {
    setLoading(true);
    try {
      const params = { limit: 50 };
      if (module) params.module = module;
      const r = await api.get("/audit-logs", { params });
      setRows(r.data?.data || []);
    } catch {} finally { setLoading(false); }
  };
  useEffect(() => { load(); }, [module]); // eslint-disable-line

  return (
    <div className="px-4 pt-4 pb-6">
      <div className="text-lg font-heading font-bold text-slate-900 mb-3">Audit Logs</div>

      {/* Module filter chips */}
      <div className="flex gap-1.5 overflow-x-auto scrollbar-hide pb-2 mb-3">
        <button onClick={() => setModule("")}
          className={`flex-shrink-0 px-3 py-1.5 rounded-full text-xs font-semibold border transition-all ${module === "" ? "bg-blue-50 text-blue-700 border-blue-200" : "bg-white text-slate-500 border-slate-200"}`}>
          All
        </button>
        {MODS.map(m => (
          <button key={m} onClick={() => setModule(m === module ? "" : m)}
            className={`flex-shrink-0 px-3 py-1.5 rounded-full text-xs font-semibold border transition-all ${module === m ? "bg-blue-50 text-blue-700 border-blue-200" : "bg-white text-slate-500 border-slate-200"}`}>
            {m}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="flex justify-center pt-8"><Loader2 className="animate-spin text-slate-400" /></div>
      ) : rows.length === 0 ? (
        <div className="text-center pt-10 text-sm text-slate-400">No audit entries</div>
      ) : (
        <div className="space-y-2">
          {rows.map(r => (
            <div key={r.id} className="bg-white rounded-2xl border border-slate-100 p-3.5">
              <div className="flex items-start justify-between gap-2 mb-1">
                <div className="flex items-center gap-1.5 flex-wrap">
                  <span className="badge-base bg-slate-50 text-slate-700 border-slate-200">{r.module}</span>
                  <span className="badge-base bg-blue-50 text-blue-700 border-blue-200">{r.source || "Web"}</span>
                </div>
                <div className="text-[10px] text-slate-400 whitespace-nowrap flex-shrink-0">{fmtDate(r.created_at)}</div>
              </div>
              <div className="font-mono text-xs text-slate-700 font-semibold">{r.action}</div>
              {r.user_name && <div className="text-xs text-slate-500 mt-0.5">by {r.user_name}</div>}
              {r.remarks && <div className="text-xs text-slate-400 mt-1 italic">"{r.remarks}"</div>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
